import { useLocation, useNavigate } from "react-router";
import Hdashboard from "../../../components/Hdashboard";
import React, { useEffect, useState } from "react";
import { RefundTransactionDetail } from "../../../api/apiHandler";
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";
import { formatAmount } from "../../../utils/formatMoney";

export default function MeetingRefundDetails({ isLoader }) {

    const navigate = useNavigate();
    const location = useLocation();
    const row = location.state;
    const [detail, setDetail] = useState(null);

    useEffect(() => {
        if (!row?.refund_id) return;
        isLoader(true);
        RefundTransactionDetail({ refund_id: row.refund_id })
            .then((response) => {
                if (response.code === "1") {
                    setDetail(response.data);
                } else {
                    setDetail(null);
                }
                isLoader(false);
            })
            .catch(() => {
                setDetail(null);
                isLoader(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [row?.refund_id]);

    const handleBack = () => {
        navigate(-1);
    };

    return <>
        <JqueryLoad />
        <Hdashboard />
        <header className="dashboard-toolbar d-lg-flex justify-content-between">
            <div className="align-items-center justify-content-between d-flex">
                <div className="d-flex align-items-center">
                    <a className="menu-toggle align-items-center d-lg-none d-flex">
                        <i className="fa fa-bars" />
                    </a>
                    <a href="index.php" className="d-lg-none d-block brand-logo">
                        <img src="./assets/images/logo.png" alt="logo" />
                    </a>
                </div>
            </div>
        </header>

        <section className="main_sec">
            <div className="mx-5 mt-4">
                <div>
                    <span onClick={handleBack}>
                        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.86172 2.225L8.37839 0.75L0.136719 9L8.38672 17.25L9.86172 15.775L3.08672 9L9.86172 2.225Z" fill="#131313" ></path>
                        </svg>
                        <span className="ms-2">Back</span>
                    </span>
                </div>
                <p className="ms-3 fs-4 fw-500 text-center mb-5">Meeting Refund Details</p>

                {detail && (
                    <div className="row d-flex justify-content-center align-items-center mb-5">
                        <div className="col col-lg-8 mb-4 mb-lg-0">
                            <div className="card mb-3 p-3" style={{ borderRadius: ".5rem" }}>
                                <div className="row g-0">
                                    <div className="col-md-12">
                                        <div className="card-body p-4">
                                            <h6 className="mb-2">Information</h6>
                                            <hr className="mt-0 mb-4" />
                                            <div className="row pt-1">
                                                <div className="col-6 mb-3">
                                                    <p className="fw-600">Initiated By</p>
                                                    <p className="text-muted mt-2">{detail.initiated_by}</p>
                                                </div>
                                                <div className="col-6 mb-3">
                                                    <p className="fw-600">Refund Date</p>
                                                    <p className="text-muted mt-2">{detail.refund_date}</p>
                                                </div>
                                                <div className="col-6 mb-3">
                                                    <p className="fw-600">Teacher</p>
                                                    <p className="text-muted mt-2">{detail.teacher_name}</p>
                                                </div>
                                                <div className="col-6 mb-3">
                                                    <p className="fw-600">Learner</p>
                                                    <p className="text-muted mt-2">{detail.learner_name}</p>
                                                </div>
                                                <div className="col-6 mb-3">
                                                    <p className="fw-600">Class</p>
                                                    <p className="text-muted mt-2">{detail.activity_title}</p>
                                                </div>
                                                <div className="col-6 mb-3">
                                                    <p className="fw-600">Stripe Refund Reference</p>
                                                    <p className="text-muted mt-2">{detail.refund_id}</p>
                                                </div>
                                                <div className="col-6 mb-3">
                                                    <p className="fw-600">Stripe Payment Intent</p>
                                                    <p className="text-muted mt-2">{detail.transaction_id}</p>
                                                </div>
                                                <div className="col-6 mb-3">
                                                    <p className="fw-600">Base Amount</p>
                                                    <p className="text-muted mt-2">${formatAmount(detail.base_amount)}</p>
                                                </div>
                                                <div className="col-6 mb-3">
                                                    <p className="fw-600">Tax</p>
                                                    <p className="text-muted mt-2">${formatAmount(detail.tax_amount)}</p>
                                                </div>
                                                <div className="col-6 mb-3">
                                                    <p className="fw-600">Total Refunded</p>
                                                    <p className="text-muted mt-2">${formatAmount(detail.refund_amount)}</p>
                                                </div>
                                            </div>

                                            <h6 className="mb-2 mt-4">Refunded Meetings</h6>
                                            <hr className="mt-0 mb-4" />
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>Time</th>
                                                        <th>Base</th>
                                                        <th>Tax</th>
                                                        <th>Refunded</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(detail.meetings || []).map((meeting, index) => (
                                                        <tr key={meeting.meeting_id || index}>
                                                            <td>{meeting.date}</td>
                                                            <td>{meeting.start_time} - {meeting.end_time}</td>
                                                            <td>${formatAmount(meeting.base_amount)}</td>
                                                            <td>${formatAmount(meeting.tax_amount)}</td>
                                                            <td>${formatAmount(meeting.refund_amount)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </section>
    </>
}
